/* Debounce function will wait until the last time the function is called and then fire after a predetermined amount of time or once the event firing becomes inactive. */
/* source: https://medium.com/@TCAS3/debounce-deep-dive-javascript-es6-e6f8d983b7a1 */
const debounce = (fn, time) => {
  let timeout;

  return function () {
    const functionCall = () => fn.apply(this, arguments);

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

export default debounce;
